import React, { useState } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { HOMEPAGE_GA_TAGS, HOMEPAGE_SECTIONS } from 'Utilities/analytics/analyticsHomePage';
import { TRUSTPILOT_REVIEW_COUNT } from 'Utilities/reviews';

import { TrustpilotReviewsCarousel } from 'Components/reviews/ReviewsCarousel/TrustpilotReviewsCarousel';
import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';
import LocalTexts from '../../HomepageTexts.json';
import { Heading } from '../Heading/Heading';

import styles from './Reviews.scss';

const LocalT = new MDText(LocalTexts);

const t = (key: string, args?: Record<string, string>) => LocalT.translate(key, args) as string;

const texts = {
  highlightedWord: t('reviews.highlightedWord'),
  title: t('reviews.title', { reviewCount: TRUSTPILOT_REVIEW_COUNT }),
};

type Props = {
  readonly className?: string;
}

export const Reviews = ({ className }: Props) => {
  const onRefTrigger = () => {
    HOMEPAGE_GA_TAGS.SECTION_LOADED(HOMEPAGE_SECTIONS.REVIEWS);
  };
  const { setRef } = usePageRefEvents({ onRefTrigger });
  const [failedLoad, setFailedLoad] = useState<boolean>(false);

  return (
    <>
      {
        !failedLoad
        && <RoundedSection>
          <div ref={(ref) => setRef(ref)} className={cx(styles.component, className)} data-testid='reviews'>
            <Content className={styles.headingWrapper}>
              <Heading
                center
                title={texts.title}
              />
            </Content>
            <TrustpilotReviewsCarousel {...{ failedLoad, setFailedLoad }} className={styles.trustpilot} title="" />
          </div>
        </RoundedSection>
      }
    </>
  );
};
